import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Card, CardBody, Collapse, Button, ModalFooter, ModalBody, ModalHeader } from 'reactstrap';
import './style.scss';
import EntityDetailsForm from './EntityDetailsForm/index';
import CorrespondentUserDetails from './UserDetailsForm/index';
import SectionDetailsList from './SectionDetails/index';
import { getStatesList } from '../../Corporate/Create/action';
// import { fetchSectionList } from '../../Corporate/Create/action';
import Modal from '../../../components/UI/Modal/Modal';
import { toast } from 'react-toastify';
import { Preloading } from '../../../components/UI/Preloader/action';
import { VALIDATION_MESSAGE_REQUIRED, ENTITY_FORM_INITIAL_VALUES, USER_FORM_INITIAL_VALUES } from './constants';
import { sectionDataValues, getTotalUsersCount, getSelectedSectionData, updateSectionDataValue, getRequestBody, setEntityDetails, validateCorrespondentOnboarding } from './helper';
import { fetchCorrespondentEntityDetails, createCorrespondentEntity, editCorrespondentEntity } from './action';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';

class CreateCorrespondent extends Component {
    constructor() {
        super();
        this.state = {
            onboardingValidationFlag: true,
            correspondentEntityDetailsFlag: false,
            userFormDetailsFlag: false,
            sectionListFlag: false,
            entityFormInitialValues: ENTITY_FORM_INITIAL_VALUES,
            userFormInitialValues: USER_FORM_INITIAL_VALUES,
            allUsers: [],
            userCount: 0,
            sectionList: [],
            sectionData: [],
            entityData: [],
            stateList: [],
            showModal: false,
            body: null
        }
    }
    componentDidMount() {
        setPageView('/Admin/Correspondent/Create', document.location.href);
        this.props.getStatesList();
        if (this.props.match.params.correspondentId) {
            this.props.preloading(true)
            this.props.fetchCorrespondentEntityDetails(this.props.match.params.correspondentId);
        } else {
            this.props.fetchCorrespondentEntityDetails('');
        }
    }

    componentDidUpdate(prevProps) {
        const { stateList, correspondentEntityDetails, correspondentEntityDetailsFailure, correspondentCreatedSuccess, correspondentCreatedFailure,
            correspondentEditSuccess, correspondentEditFailure } = this.props
        if (this.props.onBoardingPageType !== prevProps.onBoardingPageType) {
            this.props.fetchCorrespondentEntityDetails('');
            this.setState({
                sectionList: [],
                sectionData: [],
                allUsers: [],
                userCount: 0,
                entityData: {},
                onboardingValidationFlag: true
            });
        }
        if (stateList !== prevProps.stateList) {
            this.setState({
                stateList: this.props.stateList.data
            })
        }
        if (correspondentEntityDetails !== prevProps.correspondentEntityDetails) {
            const tempSectionData = sectionDataValues(correspondentEntityDetails.data.sectionList);
            if (this.props.match.params.correspondentId) {
                const sectionDataEdit = updateSectionDataValue(correspondentEntityDetails.data, tempSectionData)// edit cycle
                this.props.preloading(false)
                this.setState({
                    sectionList: sectionDataEdit,
                    sectionData: correspondentEntityDetails.data.correspondentEntity.offerings,
                    allUsers: correspondentEntityDetails.data.correspondentUsersList,
                    userCount: correspondentEntityDetails.data.correspondentUsersList.length,
                    entityData: setEntityDetails(correspondentEntityDetails.data.correspondentEntity),
                    onboardingValidationFlag: false
                })
            } else {
                this.setState({
                    sectionList: tempSectionData
                })
            }
        }
        if (correspondentEntityDetailsFailure !== prevProps.correspondentEntityDetailsFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{(correspondentEntityDetailsFailure.response && correspondentEntityDetailsFailure.response.data) ? correspondentEntityDetailsFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }
        if (correspondentCreatedSuccess !== prevProps.correspondentCreatedSuccess) {
            goolgeAnalyticsEvents('Admin', 'Onboarding Correspondent', 'Create New Correspondent', '')
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Success</ModalHeader>
                    <ModalBody>
                        <p className="text-success">{correspondentCreatedSuccess.data.message}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleToggle}>Close</Button>
                        <Button color="primary" onClick={this.handleRedirect}>View changes</Button>
                    </ModalFooter>
                </div>
            }))
        }
        if (correspondentCreatedFailure !== prevProps.correspondentCreatedFailure) {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp;{(correspondentCreatedFailure.response && correspondentCreatedFailure.response.data) ? correspondentCreatedFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }
        if (correspondentEditSuccess !== prevProps.correspondentEditSuccess) {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Success</ModalHeader>
                    <ModalBody>
                        <p className="text-success">Entity Edited Successfully</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleToggle}>Close</Button>
                        <Button color="primary" onClick={this.handleRedirect}>View changes</Button>
                    </ModalFooter>
                </div>
            }))
        } else if (correspondentEditFailure !== prevProps.correspondentEditFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{(correspondentEditFailure.response && correspondentEditFailure.response.data) ? correspondentEditFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }
    }
    handleRedirect = () => {
        this.props.history.push('/correspondent/list')
    }
    toggleSectionList = () => {
        this.setState(prevState => ({
            sectionListFlag: !prevState.sectionListFlag,
            correspondentEntityDetailsFlag: false,
            userFormDetailsFlag: false
        }))
    }
    toggleUserDetails = () => {
        this.setState(prevState => ({
            userFormDetailsFlag: !prevState.userFormDetailsFlag,
            correspondentEntityDetailsFlag: false,
            sectionListFlag: false
        }))
    }
    toggleCorrepondentEntityDetails = () => {
        this.setState(prevState => ({
            correspondentEntityDetailsFlag: !prevState.correspondentEntityDetailsFlag,
            userFormDetailsFlag: false,
            sectionListFlag: false
        }))
    }
    handleUserFormCallback = (data, validate) => {
        if (validate.validationFlag) {
            this.setState({
                allUsers: data,
                userCount: getTotalUsersCount(data)
            })
            if (validateCorrespondentOnboarding(this.state.entityData, data)) {
                this.setState({
                    onboardingValidationFlag: false
                })
            } else {
                this.setState({
                    onboardingValidationFlag: true
                })
            }
        } else {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Error</ModalHeader>
                    <ModalBody>
                        <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;{validate.message}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleToggle}>Close</Button>
                    </ModalFooter>
                </div>
            }))
        }
    }
    handleToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }))
    }
    sectionListCallback = (data) => {
        const selectedSectionData = getSelectedSectionData(data);
        this.setState({
            sectionData: selectedSectionData
        })
    }
    handleDeleteUser = (data) => {
        this.setState({
            allUsers: data,
            userCount: getTotalUsersCount(data)
        })
    }
    handleEntityFormCallback = (data, validationFlag) => {
        if (validationFlag) {
            this.setState({
                entityData: data
            })
            if (validateCorrespondentOnboarding(data, this.state.allUsers)) {
                this.setState({
                    onboardingValidationFlag: false
                })
            } else {
                this.setState({
                    onboardingValidationFlag: true
                })
            }
        } else {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Error</ModalHeader>
                    <ModalBody>
                        <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;{VALIDATION_MESSAGE_REQUIRED}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleToggle}>Close</Button>
                    </ModalFooter>
                </div>
            }))
        }
    }
    handleCreateCorrespondent = () => {
        const requestBody = getRequestBody(this.state.entityData, this.state.allUsers, this.state.sectionData);
        if (this.props.match.params.correspondentId) {
            this.props.editCorrespondentEntity(requestBody)
        } else {
            this.props.createCorrespondentEntity(requestBody);
        }

    }
    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3" >
                    <h5 className="mb-0">
                        Create Correspondent
                    </h5>
                    {/* <div className='error'>Error</div> */}
                </div>
                <Card className="mb-70 correspondent-onboarding">
                    <CardBody>
                        <Row>
                            <Col xs="9" className="border-right">
                                <div style={{ height: 600 }}>
                                    <article className="collapse-company-details">
                                        <div data-target="#collapse1" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={this.toggleCorrepondentEntityDetails} >
                                            <h5>Correspondent Entity Details</h5>
                                            <i></i>
                                        </div>
                                    </article>
                                    {(this.state.entityData.correspondentEntityName) ?
                                        <div className="px-3 mb-3">
                                            <Row className="border-bottom font-weight-bold">
                                                <Col sm="12">Company Name</Col>
                                                <Col sm="12">{(this.state.entityData.gstNum) ? 'GST Number' : 'PAN Number'}</Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">{this.state.entityData.correspondentEntityName}</Col>
                                                <Col sm="12">{(this.state.entityData.gstNum) ? this.state.entityData.gstNum : this.state.entityData.panNo}</Col>
                                            </Row>
                                        </div> : <div></div>
                                    }


                                    <article className="collapse-company-details">
                                        <div data-target="#collapse2" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={this.toggleUserDetails} >
                                            <h5>Correspondent User(s) Details ({this.state.userCount})</h5>
                                            <i></i>
                                        </div>
                                    </article>
                                    <article className="collapse-company-details">
                                        <div data-target="#collapse3" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={this.toggleSectionList} >
                                            <h5>Correspondent Section Details ({this.state.sectionData.length})</h5>
                                            <i></i>
                                        </div>
                                    </article>
                                </div>
                            </Col>
                            <Col xs="15">

                                <Collapse id="collapse1" isOpen={this.state.correspondentEntityDetailsFlag}>
                                    <EntityDetailsForm correspondentId={this.props.match.params.correspondentId} entityDetails={this.state.entityData} stateList={this.state.stateList} initialValues={this.state.entityFormInitialValues} entityFormCallback={this.handleEntityFormCallback} />
                                </Collapse>
                                <Collapse id="collapse2" isOpen={this.state.userFormDetailsFlag}>
                                    <CorrespondentUserDetails correspondentId={this.props.match.params.correspondentId} userDetails={this.state.allUsers} initialValues={this.state.userFormInitialValues} userFormCallback={this.handleUserFormCallback} deleteUserCallback={this.handleDeleteUser} />
                                </Collapse>
                                <Collapse id="collapse3" isOpen={this.state.sectionListFlag}>
                                    <SectionDetailsList sectionList={this.state.sectionList} sectionDetailsCallback={this.sectionListCallback} />
                                </Collapse>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <footer className="bg-light footer w-100 text-center">
                    <Button color="primary" disabled={this.state.onboardingValidationFlag} onClick={this.handleCreateCorrespondent}>
                        Finish
                        &nbsp;&nbsp;<i className="fa fa-angle-double-right"></i>
                    </Button>
                </footer>
                <Modal show={this.state.showModal} className='Modal' >
                    {this.state.body}
                </Modal>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    stateList: state.corporateOnBoardingCreate.statesListSuccessData,
    // sectionList: state.corporateOnBoardingCreate.productSectionList
    correspondentEntityDetails: state.correspondentOnboarding.correspondentDetails,
    correspondentEntityDetailsFailure: state.correspondentOnboarding.correspondentDetailsFailure,
    correspondentCreatedSuccess: state.correspondentOnboarding.correspondentCreateSuccess,
    correspondentCreatedFailure: state.correspondentOnboarding.correspondentCreateFailure,
    correspondentEditSuccess: state.correspondentOnboarding.correspondentEditSuccess,
    correspondentEditFailure: state.correspondentOnboarding.correspondentEditFailure,
})

const mapDispatchToProps = (dispatch) => ({
    getStatesList: () => { dispatch(getStatesList()) },
    fetchCorrespondentEntityDetails: (id) => { dispatch(fetchCorrespondentEntityDetails(id)) },
    createCorrespondentEntity: (data) => { dispatch(createCorrespondentEntity(data)) },
    editCorrespondentEntity: (data) => { dispatch(editCorrespondentEntity(data)) },
    preloading: (status) => { dispatch(Preloading(status)) }
});
export default connect(mapStateToProps, mapDispatchToProps)(CreateCorrespondent);
